import { SensitivityItem } from './sensitivity-item.model';

export interface SensitivityInterface {
  inputs: SensitivityItem[];
  results: any;
}

export class Sensitivity {
  inputs: SensitivityItem[] = [];
  results: any;

  constructor(param: SensitivityInterface = {
    inputs: [],
    results: null,
  }) {
    this.inputs = [];
    if (param.inputs && Array.isArray(param.inputs)) {
      for (const input of param.inputs) {
        const sensItem = new SensitivityItem(input);
        if (sensItem) {
          this.inputs.push(sensItem);
        }
      }
    }
    this.results = param.results;
  }

  static deepCopy(sens: Sensitivity) {
    let copy: Sensitivity;
    if (sens) {
      copy = new Sensitivity(JSON.parse(JSON.stringify(sens)));
      return copy;
    }
    throw new Error('sensitivity deep copy failed');
  }

  hasInputs() {
    return !(!this.inputs || this.inputs.length < 1);
  }

  inputsAreValid() {
    if (!this.inputs || this.inputs.length < 1) {
      return false;
    }
    for (const input of this.inputs) {
      if (!input.id || !input.nameElements || input.nameElements.length < 1) {
        return false;
      }
    }
    return true;
  }
}
